import { Router } from '@angular/router';

export abstract class BasePageComponent {
  protected redirecting: boolean = false;

  constructor(
    hasLoadRights: boolean,
    router: Router) {
    if (!hasLoadRights) {
      router.navigate(["/"]);
      this.redirecting = true;
    }
   }

}